export const readLocalStorage = (item) => localStorage.getItem(item);
export const writeLocalStorage = (item, data) => localStorage.setItem(item, data);
export const clearLocalStorage = (item) => localStorage.removeItem(item);